import { render, staticRenderFns } from "./ArticleInfoCover.vue?vue&type=template&id=a9b34c8a&scoped=true&"
import script from "./ArticleInfoCover.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoCover.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfoCover.vue?vue&type=style&index=0&id=a9b34c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b34c8a",
  null
  
)

export default component.exports